import { render, staticRenderFns } from "./UIModal.vue?vue&type=template&id=efba2272&"
import script from "./UIModal.vue?vue&type=script&lang=js&"
export * from "./UIModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports